import React, { useEffect, useState } from 'react';
import client from '../api/client';
import { useAuth } from '../context/AuthContext';

const empty = { code: '', name_ar: '', name_en: '', color_code: '#1e3a8a', description: '' };

export default function Categories() {
  const { user } = useAuth();
  const isAdmin = user.role === 'admin';
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState(empty);
  const [editingId, setEditingId] = useState(null);
  const [error, setError] = useState(null);

  const load = () => client.get('/categories').then(r => setRows(r.data));
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      if (editingId) await client.put(`/categories/${editingId}`, form);
      else await client.post('/categories', form);
      setForm(empty); setEditingId(null);
      load();
    } catch (err) { setError(err.response?.data?.message || 'خطأ'); }
  };

  const edit = (c) => {
    setForm({ code: c.code, name_ar: c.name_ar, name_en: c.name_en || '', color_code: c.color_code, description: c.description || '' });
    setEditingId(c.id);
  };

  const remove = async (id) => {
    if (!window.confirm('تأكيد الحذف؟')) return;
    try { await client.delete(`/categories/${id}`); load(); }
    catch (err) { alert(err.response?.data?.message || 'خطأ'); }
  };

  return (
    <div className="grid grid-2">
      <div className="card">
        <h3 style={{ marginTop: 0 }}>{editingId ? 'تعديل فئة اعتماد' : 'إضافة فئة اعتماد'}</h3>
        {error && <div className="alert alert-error">{error}</div>}
        <form onSubmit={submit}>
          <div className="form-field" style={{ marginBottom: 10 }}>
            <label>الرمز (Code) *</label>
            <input value={form.code} onChange={e => setForm({ ...form, code: e.target.value })} required disabled={!!editingId} />
          </div>
          <div className="form-field" style={{ marginBottom: 10 }}>
            <label>الاسم (عربي) *</label>
            <input value={form.name_ar} onChange={e => setForm({ ...form, name_ar: e.target.value })} required />
          </div>
          <div className="form-field" style={{ marginBottom: 10 }}>
            <label>الاسم (English)</label>
            <input value={form.name_en} onChange={e => setForm({ ...form, name_en: e.target.value })} />
          </div>
          <div className="form-field" style={{ marginBottom: 10 }}>
            <label>لون البطاقة</label>
            <input type="color" value={form.color_code} onChange={e => setForm({ ...form, color_code: e.target.value })} />
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button className="btn btn-primary">{editingId ? 'حفظ التعديلات' : 'إضافة'}</button>
            {editingId && <button type="button" className="btn btn-outline" onClick={() => { setEditingId(null); setForm(empty); }}>إلغاء</button>}
          </div>
        </form>
      </div>

      <div className="card">
        <h3 style={{ marginTop: 0 }}>الفئات ({rows.length})</h3>
        <table>
          <thead><tr><th>الاسم</th><th>اللون</th><th></th></tr></thead>
          <tbody>
            {rows.map(c => (
              <tr key={c.id}>
                <td>{c.name_ar}</td>
                <td><span className="badge" style={{ background: c.color_code }}>{c.code}</span></td>
                <td style={{ display: 'flex', gap: 6 }}>
                  <button className="btn btn-outline" onClick={() => edit(c)}>تعديل</button>
                  {isAdmin && <button className="btn btn-danger" onClick={() => remove(c.id)}>حذف</button>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
